module.exports = __webpack_public_path__ + "img/i_o_del.a4eb51af.svg";